import { AdSet } from '../../../entities/ad-set';
import { NpiSourceInterface } from '../../../interfaces/components/npi/npi-source.interface';
import { Event } from '../event';

export class NpiPreDetectEvent extends Event {
  public constructor (protected readonly adSet: AdSet, protected readonly source: NpiSourceInterface) {
    super();
  }

  public getAdSet (): AdSet {
    return this.adSet;
  }

  public getSource (): NpiSourceInterface {
    return this.source;
  }
}
